import { z } from "zod";
import { safeUrlSchema, safeHttpUrlSchema } from "../safe-url";

export const socialPlatformEnum = z.enum([
  "scholar",
  "orcid",
  "researchgate",
  "linkedin",
  "github",
  "twitter",
  "youtube",
  "facebook",
  "instagram",
  "website",
  "other",
]);

export type SocialPlatform = z.infer<typeof socialPlatformEnum>;

export const draftSocialLinkSchema = z.object({
  id: z.string().optional(),
  platform: socialPlatformEnum,
  url: z.string().max(1024).optional().or(z.literal("")).default(""),
  label: z.string().max(100, "Label too long").optional().nullable(),
});

export const socialLinkSchema = z.object({
  id: z.string().optional(),
  platform: socialPlatformEnum,
  url: safeUrlSchema,
  label: z.string().max(100, "Label too long").optional().nullable(),
});

export type SocialLink = z.infer<typeof socialLinkSchema>;
export type DraftSocialLink = z.infer<typeof draftSocialLinkSchema>;

import { getSectionDisplayOptionsSchema } from "../display-options";

export const contactDisplayOptionsSchema = getSectionDisplayOptionsSchema("contact");
export type ContactDisplayOptions = z.infer<typeof contactDisplayOptionsSchema>;

export const draftContactContentSchema = z.object({
  heading: z.string().max(200).default("Contact & Profiles").optional(),
  email: z.string().max(320).optional().or(z.literal("")).nullable(),
  phone: z.string().max(50, "Phone number too long").optional().nullable(),
  office: z.string().max(500, "Office location too long").optional().nullable(),
  address: z.string().max(1000, "Address too long").optional().nullable(),
  website: z.string().max(1024).optional().or(z.literal("")).nullable(),
  showContactForm: z.boolean().default(false).optional(),
  socialLinks: z.array(draftSocialLinkSchema).max(20, "Maximum 20 social links allowed").optional().default([]),
  displayOptions: contactDisplayOptionsSchema.optional(),
});



export const contactContentSchema = z.object({
  heading: z.string().max(200).default("Contact & Profiles").optional(),
  email: z.string().email("Invalid email address").max(320).optional().or(z.literal("")).nullable(),
  phone: z.string().max(50, "Phone number too long").optional().nullable(),
  office: z.string().max(500, "Office location too long").optional().nullable(),
  address: z.string().max(1000, "Address too long").optional().nullable(),
  website: safeHttpUrlSchema.optional().or(z.literal("")).nullable(),
  showContactForm: z.boolean().default(false).optional(),
  socialLinks: z.array(socialLinkSchema).max(20, "Maximum 20 social links allowed").optional().default([]),
  displayOptions: contactDisplayOptionsSchema.optional(),
});

export type ContactContent = z.infer<typeof contactContentSchema>;
export type DraftContactContent = z.infer<typeof draftContactContentSchema>;
